export default __webpack_public_path__ + "static/media/search_icon.a5d448e7.svg";